import { Reveal, StaggerGroup, StaggerItem } from "@/components/Reveal";
import { TextCTA } from "@/components/CTA";
import { Spotlight } from "@/components/Sketches";
import { ROUTES } from "@/config/links";
import { useLang } from "@/i18n";

export const WhoFor = () => {
  const { t } = useLang();
  const situations = t("landing.whofor_situations");
  return (
    <section className="relative z-10 py-24 md:py-36 bg-ink text-paper overflow-hidden" data-testid="whofor-section">
      <span className="pointer-events-none select-none absolute -top-10 right-0 font-serif text-[26vw] leading-none text-paper/[0.04]">
        who
      </span>
      <Spotlight className="hidden lg:block absolute right-10 bottom-0 w-72 h-[420px] opacity-40 pointer-events-none" animate={false} label={false} invert />

      <div className="max-w-[1400px] mx-auto px-5 md:px-10 relative">
        <Reveal className="max-w-3xl mb-14 md:mb-20">
          <p className="font-body text-xs uppercase tracking-[0.24em] text-terracotta mb-5">
            {t("landing.whofor_eyebrow")}
          </p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight mb-6">
            {t("landing.whofor_h")}
          </h2>
          <p className="hidden md:block font-body text-paper/70 leading-relaxed max-w-xl" data-testid="whofor-body-desktop">
            {t("landing.whofor_body")}
          </p>
          <p className="md:hidden font-body text-paper/70 leading-relaxed" data-testid="whofor-body-mobile">
            {t("landing.whofor_body_mobile")}
          </p>
        </Reveal>

        <StaggerGroup className="grid md:grid-cols-2 gap-px bg-paper/15 border border-paper/15" stagger={0.06}>
          {Array.isArray(situations) &&
            situations.map((s, i) => (
              <StaggerItem key={i}>
                <div className="bg-ink p-7 md:p-9 h-full" data-testid={`whofor-situation-${i}`}>
                  <span className="font-hand text-terracotta text-xl block mb-3">{String(i + 1).padStart(2, "0")}</span>
                  <h3 className="font-serif text-xl md:text-2xl text-paper mb-2 tracking-tight">{s.title}</h3>
                  <p className="font-body text-paper/70 leading-relaxed">{s.body}</p>
                </div>
              </StaggerItem>
            ))}
        </StaggerGroup>

        <Reveal delay={0.1} className="mt-10 md:mt-12">
          <TextCTA
            href={ROUTES.executivePresenceDevelopment}
            testId="whofor-epd-cta"
            className="!text-paper/85 hover:!text-mustard"
          >
            {t("landing.whofor_secondary")}
          </TextCTA>
        </Reveal>
      </div>
    </section>
  );
};
